<script setup lang="ts">
import type { KanbanLog } from '@entities/kanban-comment'

import { useKanbanLogItem } from '@entities/kanban-comment'
import { AppText } from '@shared/ui/typography'

defineOptions({
  name: 'KanbanLogItem',
})

const props = defineProps<{
  log: KanbanLog
  main: boolean
  last: boolean
}>()

const refLog = computed<KanbanLog>(() => props.log)

const {
  refDate,
} = useKanbanLogItem(refLog)
</script>

<template>
  <div :class="['kanban-log-item', { main, last }]">
    <div
      v-if="main"
      class="kanban-log-item__stage"
    >
      <slot name="stage" />
    </div>
    <div class="kanban-log-item__general">
      <AppText
        name="body2"
        color="slate-500"
        class="kanban-log-item__date"
      >
        {{ refDate }}
      </AppText>
      <div class="kanban-log-item__info">
        <slot />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss" src="@shared/ui/kanban/styles/_kanban-log-item.scss" />